import { ProvinceService } from './../../../../../services/province/province.service';
import { ToponymService } from './../../../../../services/toponym/toponym.service';
import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';
import { ConfirmationService, SelectItem } from 'primeng/components/common/api';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-new-address-form',
  templateUrl: './new-address-form.component.html',
  styleUrls: ['./new-address-form.component.css']
})
export class NewAddressFormComponent implements OnInit {
  newAddressForm: FormGroup;
  provinceErrorMsg: string;
  invalidSubmit = false;
  toponyms: SelectItem[] = [{value: null, label: ''}];
  provinces: SelectItem[] = [{value: null, label: ''}];
  @Input() editAddress: boolean;
  @Input() customerAddressList: any[] = [];
  @Input() selectedCustomerAddress: string;
  @Output() addressUpdated: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    private giftService: LoyaltyGiftReservationService,
    private toponymService: ToponymService,
    private provinceService: ProvinceService
  ) { }

  get addressForm() {
    return this.newAddressForm.controls;
  }

  ngOnInit() {
    this.toponymService.getAll().subscribe(res => {
      res.forEach(toponym => {
        this.toponyms.push({
          value: toponym.id,
          label: toponym.name
        });
      });
      this.provinceService.getAll().subscribe(provinces => {
        provinces.forEach(province => this.provinces.push({value: province.code, label: province.name}));
        if (this.editAddress) {
          this.newAddressForm = this.fb.group({
            toponym: [this.customerAddressList[this.selectedCustomerAddress].toponym, Validators.required],
            address: [this.customerAddressList[this.selectedCustomerAddress].address, Validators.required],
            number: [this.customerAddressList[this.selectedCustomerAddress].addressNo, Validators.required],
            address2: [this.customerAddressList[this.selectedCustomerAddress].address2],
            zip: [this.customerAddressList[this.selectedCustomerAddress].zipCode, Validators.required],
            city: [this.customerAddressList[this.selectedCustomerAddress].city, Validators.required],
            province: [this.customerAddressList[this.selectedCustomerAddress].provinceCode, Validators.required],
            surname: [this.customerAddressList[this.selectedCustomerAddress].surname, Validators.required],
            name: [this.customerAddressList[this.selectedCustomerAddress].name, Validators.required]
          });
        } else {
          this.newAddressForm = this.fb.group({
            toponym: ['', Validators.required],
            address: ['', Validators.required],
            number: ['', Validators.required],
            address2: [''],
            zip: ['', Validators.required],
            city: ['', Validators.required],
            province: ['', Validators.required],
            surname: ['', Validators.required],
            name: ['', Validators.required]
          });
        }
      });
    });
    this.translateService.get(['reservations.provinceError']).subscribe(res => this.provinceErrorMsg = res['reservations.provinceError']);
  }

  saveAddress() {
    if (!this.newAddressForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const selectedToponym = this.toponyms.filter(toponym => toponym.value === this.addressForm.toponym.value);
    this.giftService.getProvince(this.addressForm.province.value).subscribe(
      res => {
        if (res && res.length > 0) {
          const addressData = {
            address_type: 'delivery_address',
            name: this.addressForm.name.value,
            surname: this.addressForm.surname.value,
            toponym_id: this.addressForm.toponym.value,
            toponym: selectedToponym[0].label,
            address_1: this.addressForm.address.value,
            address_2: this.addressForm.address2.value,
            address_number: this.addressForm.number.value,
            city: this.addressForm.city.value,
            zip_code: this.addressForm.zip.value,
            province_id: res[0].id,
            province_code: this.addressForm.province.value,
            country_code: 'IT',
            contact_number: '',
            lift: '',
            notes: 'nessuna nota',
          };
          if (this.editAddress) {
            if (this.selectedCustomerAddress === '0') {
              const customerAddressData = {
                address: this.addressForm.address.value,
                address_2: this.addressForm.address2.value,
                address_number: this.addressForm.number.value,
                zip_code: this.addressForm.zip.value,
                province_id: res[0].id,
                country_id: 7,
                state_id: null,
                toponym: selectedToponym[0].label,
                toponym_id: this.addressForm.toponym.value,
                city: this.addressForm.city.value
              }
              this.giftService.editCustomerAddress(customerAddressData).subscribe(() => this.addressUpdated.emit(this.selectedCustomerAddress));
            } else {
              this.giftService.editAddress(addressData, this.selectedCustomerAddress).subscribe(() => this.addressUpdated.emit(this.selectedCustomerAddress));
            }
          } else {
            this.giftService.addAddress(addressData).subscribe(() => this.addressUpdated.emit('new address'));
          }
        } else {
          this.confirmationService.confirm({
            message: this.provinceErrorMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
        }
      },
      err => {
        console.error(err);
        this.confirmationService.confirm({
          message: this.provinceErrorMsg,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      }
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-gift-reservation/confirm-gift-reservation-form/new-address-form/new-address-form.component.ts